import React from "react";

import MuiFormLabel from "@mui/material/FormLabel";
import Menu from "@mui/material/Menu";
import styled from "@mui/material/styles/styled";
import Typography, { TypographyProps } from "@mui/material/Typography";

import { SyncIcon } from "@app/common/assets/icons";

import Button, { ButtonProps } from "@rui/Button";
import { Row } from "@rui/Stack";
import { spin } from "@rui/styles";

export const Container = styled(Row)(({ theme }) => ({
  padding: theme.spacing(3),
  borderBottom: `1px solid ${theme.palette.shades.neutral[100]}`,
  boxShadow: "0px 4px 24px 0px rgba(0, 0, 0, 0.04)",
  backgroundColor: "#fff",
  width: "100%",
}));

export const PremiumChip = styled<React.FC<TypographyProps>>((props) => (
  <Typography variant="labelMed" {...props}>
    Premium
  </Typography>
))(({ theme }) => ({
  padding: "2px 4px",
  borderRadius: "4px",
  backgroundColor: theme.palette.shades.secondary[50],
  color: theme.palette.shades.secondary[600],
}));

export const CategoryLabel = styled(Typography)(({ theme }) => ({
  ...theme.typography.labelMed,
  backgroundColor: theme.palette.shades.neutral[50],
  color: theme.palette.shades.neutral[400],
  width: "fit-content",
  padding: "2px 4px",
  borderRadius: "4px",
}));

export const DisconnectButton = styled((props: ButtonProps) => (
  <Button variant="outlined" color="error" {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.shades.neutral[100]}`,
}));

export const FormSubLabel = styled(MuiFormLabel)(({ theme }) => ({
  fontFamily: theme.typography.fontFamilySecondary,
  fontWeight: 500,
}));

export const IntegrationMenu = styled(Menu)(({ theme }) => ({
  "& .MuiList-root": {
    padding: theme.spacing(1),
  },
  "& .MuiMenuItem-root .MuiSvgIcon-root": {
    color: theme.palette.shades.neutral[500],
  },
}));

export const SyncPastMeetingsButton = styled<React.FC<ButtonProps>>(
  ({ className, loading, ...props }) => (
    <Button
      {...props}
      startIcon={<SyncIcon />}
      variant="outlined"
      className={`${className}${loading ? " loading" : ""}`}
    >
      Sync past meetings
    </Button>
  )
)(({ theme }) => ({
  backgroundColor: "#FFF",
  height: "40px",
  "&.Mui-disabled": {
    borderColor: theme.palette.shades.neutral[50],
    backgroundColor: theme.palette.shades.neutral[50],
    color: theme.palette.shades.neutral[400],
  },
  "& .MuiButton-startIcon svg": {
    fontSize: "16px",
    animation: `${spin} 1s linear infinite`,
    animationPlayState: "paused",
  },
  "&.loading .MuiButton-startIcon svg": {
    animationPlayState: "running",
  },
}));
